import { ConcreteEncodable } from "./ConcreteEncodable";

import { DealComponentDetailsImplEncoder } from "../../encoder/DealComponentDetailsImplEncoder";

import * as CubiqTS from "../../index";
import { DealComponentDetails } from "../DealComponentDetails";

export class DealComponentDetailsImpl extends ConcreteEncodable implements DealComponentDetails {
  public static enType: string = "com.bcdfx.model.DealComponentDetailsImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=120*/
  public baseCcyCd: string;
  /*FID=121*/
  public nonBaseCcyCd: string;
  /*FID=122*/
  public spotRt: CubiqTS.BigNumber | null = null;
  /*FID=123*/
  public outrightRt: CubiqTS.BigNumber | null = null;
  /*FID=124*/
  public dealerMargin: CubiqTS.BigNumber | null = null;
  /*FID=125*/
  public marketRt: CubiqTS.BigNumber | null = null;
  /*FID=126*/
  public localBookName: string;
  /*FID=127*/
  public remoteBookName: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = DealComponentDetailsImplEncoder.Instance;
    this.setEncodableType(DealComponentDetailsImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "DealComponentDetailsImpl[" +
      "messageId=" +
      this.messageId +
      "baseCcyCd=" +
      this.baseCcyCd +
      "nonBaseCcyCd=" +
      this.nonBaseCcyCd +
      "spotRt=" +
      this.spotRt +
      "outrightRt=" +
      this.outrightRt +
      "dealerMargin=" +
      this.dealerMargin +
      "marketRt=" +
      this.marketRt +
      "localBookName=" +
      this.localBookName +
      "remoteBookName=" +
      this.remoteBookName +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
